import { useEffect, useState } from "react";

import { getItemFromStore } from "@helpers/utils";
import size from "lodash/size";

function reorderColumns (metrics, cols) {
    if (size(cols)) {
        const orderedColumns = [];

        if (metrics && cols) {
            for (const metric of metrics) {
                let colId = cols.find(c => c.id === metric)?.id;
                if (!colId) {
                    colId = metric;
                }

                for (const column of cols) {
                    if (column.id === colId) {
                        orderedColumns.push(column);
                        break;
                    }
                }
            }
        }
        return orderedColumns;
    }
}

const useReorder = props => {
    const { columns, module } = props;
    const localReorderedMetrics =
    size(module) &&
    (getItemFromStore("reordered-metrics")[module.name]?.[
        module.id
    ] ||
      module.defaultValues) ? getItemFromStore("reordered-metrics")?.[module.name]?.[
            module.id
        ] : columns.map(item => item.id || item.name);
    const [columnOrder, setColumnOrder] = useState([]);
    const [initialColumns, setInitialColumns] = useState([]);
    const [newColumns, setNewColumns] = useState([]);

    const [reOrderedDataMetrics, setReOrderedDataMetrics] = useState(
        localReorderedMetrics ?? columns
    );
    useEffect(() => {
        if (size(columns)) {
            const initialColumns = reorderColumns(localReorderedMetrics, columns);
            const initialColumnOrder = initialColumns.map((col, idx) => idx);
            setInitialColumns(initialColumns);
            setNewColumns(initialColumns);
            setColumnOrder(initialColumnOrder);
        }
    }, [columns]);

    useEffect(() => {
        if (size(columnOrder)) {
            setNewColumns([...columnOrder.map(index => initialColumns[index])]);
        }
    }, [columnOrder]);
    return {
        setColumnOrder,
        reOrderedDataMetrics,
        columnOrder,
        setReOrderedDataMetrics,
        newColumns,
        initialColumns
    };
};
export default useReorder;

export const multipleColumnFixedCSS = (fixedColumns = []) => {
    if (!fixedColumns.length) return "";
    
    let css = "";
    let leftPosition = 0;
    
    fixedColumns.forEach((config) => {
        const { index: columnIndex, width = 200 } = config;
        const selector = `.dynamic-fixed-columns .rdt_TableHeadRow > div:nth-child(${columnIndex + 1}),
                         .dynamic-fixed-columns .rdt_TableBody .rdt_TableRow > div:nth-child(${columnIndex + 1})`;
        
        css += `
        ${selector} {
            position: sticky !important;
            left: ${leftPosition}px !important;
            background: var(--bs-body-bg, white) !important;
            z-index: 2 !important;
            border-right: 2px solid #ddd !important;
            box-shadow: 2px 0 4px rgba(0,0,0,0.1);
        }`;
        
        leftPosition += width;
    });
    
    return css;
};